import TailoredActionName from '../../store/schema/telemetry/TailoredActionName';
import populateFeedbackDataPoint from '../../utils/telemetry/populateFeedbackDataPoint';
import { TxpDatapoint } from 'txp-data';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';

/**
 * Telemetry callback when useful / not useful clicked with feedbackDataPoint
 */
export default function onSentimentFeedbackClickedHandler(
    isUseful: boolean,
    onFeedbackClicked: (txpDatapoint: TxpDatapoint, datapointName: string) => void,
    entityNamesMap: number,
    origin: string,
    txpConfiguration: TxpConfiguration
) {
    if (onFeedbackClicked) {
        let feedbackClick: string = isUseful
            ? TailoredActionName.FeedbackPositive
            : TailoredActionName.FeedbackNegative;
        // Logging Txp Status data only for report issue datapoints. So sending null here.
        const dataPoint = populateFeedbackDataPoint(
            feedbackClick,
            entityNamesMap,
            origin,
            null /*txpStatus*/,
            txpConfiguration
        );
        onFeedbackClicked(dataPoint, TxpDataPointNames.TXPUserVoice);
    }
}
